"use strict";

// Export the library to the global scope:
globalThis.ngdg = require("./ngdg").ngdg;
